// extracted by mini-css-extract-plugin
export var change = "_3r-1";
export var changeList = "_3r-0";
export var changePath = "_3r-2";
export var diffArrow = "_3r-5";
export var diffRow = "_3r-3";
export var diffValue = "_3r-4";
export var error = "_3r-8";
export var notice = "_3r-9";
export var result = "_3r-6";
export var success = "_3r-7";